import { TokenService } from "../../services/TokenService";

const headers = TokenService.getHeaders();

export const FilterAPIService = {

    getFilters: async function (url) {
        let response;            
        try {            
            response = await fetch(process.env.REACT_APP_LST_API_DOMAIN + '/api/' +  url, {
                headers: headers
            });
        } catch (error) {
            if (process.env.NODE_ENV === 'development')
                console.log('There was an error', error);
            else
                console.log('There was an error, try again after sometime.');
            response = error
        }

        if (response?.ok) {
            return await response.json();
        } else {
            if (process.env.NODE_ENV === 'development')
                console.log(`HTTP Response Code: ${response?.status}`)
            return {error: response}
        }
    },    
};